/* FFL Scroll Reveal v2.1 — page-wide entrance animations + small uniformity polish for
   the custom-design page. Self-contained: injects its own CSS, targets the current section
   classes, scoped to template content sections, flash-free (already-visible elements are left
   untouched), staggered, and disabled under prefers-reduced-motion. */
(function () {
  'use strict';

  // Always-on uniformity polish (independent of motion preference):
  // recolor the reviews "Read Our Reviews" button from dark green to the page's gold.
  if (!document.getElementById('ffl-polish-css')) {
    var pc = document.createElement('style');
    pc.id = 'ffl-polish-css';
    pc.textContent =
      'a[class*="ai-reviews-btn-primary-"]{background:#b8956a!important;color:#1a1a1a!important;border-color:#b8956a!important;transition:filter .2s;}' +
      'a[class*="ai-reviews-btn-primary-"]:hover{filter:brightness(1.05);}';
    document.head.appendChild(pc);
  }

  if (window.__fflReveal) return;
  window.__fflReveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  // 1. Inject animation CSS once
  if (!document.getElementById('ffl-reveal-css')) {
    var css = document.createElement('style');
    css.id = 'ffl-reveal-css';
    css.textContent =
      '.ffl-reveal{opacity:0;transform:translateY(26px);' +
      'transition:opacity .7s cubic-bezier(.22,.61,.36,1),transform .7s cubic-bezier(.22,.61,.36,1);}' +
      '.ffl-reveal.ffl-in{opacity:1;transform:none;}' +
      '.ffl-d1{transition-delay:.07s}.ffl-d2{transition-delay:.14s}.ffl-d3{transition-delay:.21s}' +
      '.ffl-d4{transition-delay:.28s}.ffl-d5{transition-delay:.35s}';
    document.head.appendChild(css);
  }

  // 2. Elements to reveal — matches the current sections' hashed BEM classes
  var SEL = [
    'h1[class*="__h1"]', 'h2[class*="__h2"]',
    '[class*="__step"]', '[class*="__card"]', '[class*="-badge-item-"]',
    '[class*="__chapter"]', '[class*="__risk-item"]', '[class*="__proof-avatar"]',
    '[class*="__band"]', '[class*="__lead"]', '[class*="__sub"]',
    '[class*="ai-faq-accordion__item-"]', '[class*="ai-faq-accordion__title-"]',
    '[class*="ai-reviews-left-panel"]', '[class*="ai-reviews-right-panel"]',
    '[class*="ai-reviews-card-"]', '[class*="ai-reviews-photo-slide"]',
    '[class*="ai-reviews-heading-"]', '[class*="ai-reviews-subheading-"]',
    '.rup-trust__label', '.rup-trust__heading', '.rup-trust__stat', '.rup-trust__item',
    '.rup-trust__review', '.rup-form-wrap', '.rup-connect-wrap'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('ffl-in');
        observer.unobserve(en.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' });

  function collect() {
    var out = [];
    var scopes = document.querySelectorAll('.shopify-section[id*="template--"]');
    scopes.forEach(function (sec) {
      var found;
      try { found = sec.querySelectorAll(SEL); } catch (e) { return; }
      found.forEach(function (el) {
        if (!el.hasAttribute('data-ffl-r')) out.push(el);
      });
    });
    // drop nested targets (keep the outermost so we don't double-animate a card + its children)
    return out.filter(function (el) {
      for (var i = 0; i < out.length; i++) {
        if (out[i] !== el && out[i].contains(el)) return false;
      }
      return true;
    });
  }

  function init() {
    var els = collect();
    if (!els.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) { el.setAttribute('data-ffl-r', '1'); });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      // Already in (or near) view on load → leave it natural, no flash.
      if (r.top < vh * 0.92 && r.bottom > 0) return;
      el.classList.add('ffl-reveal');
      // Stagger by position among reveal siblings for a cascading feel.
      var idx = 0, p = el.previousElementSibling;
      while (p) { if (p.hasAttribute('data-ffl-r')) idx++; p = p.previousElementSibling; }
      if (idx > 0) el.classList.add('ffl-d' + Math.min(idx, 5));
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-scan for late-rendered blocks (carousels, app embeds).
  setTimeout(init, 900);
  setTimeout(init, 2200);
})();
